export const Sizes = {
	tickLineWidth: 1,
	tickLineHeight: 10,
	tickDotSize: 3,
} as const
